<div *ngIf="datos.length" class="col-sm-12 col-md-12 col-xl-12">
    <h2>Catalogos</h2>
    <app-grid-component [datos]="datos" [columns]="columns" [exportExcel]="exportExcel"
                        [columnHiding]="columnHiding" [Checkbox]="Checkbox" [Editing]="Editing"
                        [Columnchooser]="Columnchooser" [searchPanel]="searchPanel" [scroll]="scroll"
                        (messageEvent)="receiveMessage($event)" (datosevent)='datosMessage($event)' [toolbar]="toolbar"
                        (onRowUpdated)="Actializar($event)" >
    </app-grid-component>
</div>
